import { useNavigate } from 'react-router-dom';
import Url from '../../../data/url';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import { useTranslation } from '../../../hook/useTranslation';

const Title = ({ title }: { title: string }) => {
  return (
    <div className="text-[14px] text-[1C1C1C] w-full text-left font-[700] mb-[8px]">{title}</div>
  );
};
const DotText = ({ text }: { text: string }) => {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="flex items-start justify-start mt-[-4px]">･</div>
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
};
/*
const Text = ({ text }: { text: string }) => {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
};
*/

function UsageGuidePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title={t('my.usage.title')} onClickPrev={() => navigate(Url.My)} />
      <div className="pageInner bg-[#FFF]">
        <div className="text-[18px] text-[#363636] w-full text-left font-[700] my-[20px]">
          {t('my.usage.privacy_title')}
        </div>
        <div className="w-full flex flex-col justify-start items-start my-[20px] grow overflow-y-auto gap-[20px]">
          <div>
            <Title title={t('my.usage.item1_title')} />
            <DotText text={t('my.usage.item1_dot1')} />
            <DotText text={t('my.usage.item1_dot2')} />
            <DotText text={t('my.usage.item1_dot3')} />
          </div>
          <div>
            <Title title={t('my.usage.item2_title')} />
            <DotText text={t('my.usage.item2_dot1')} />
            <DotText text={t('my.usage.item2_dot2')} />
            <DotText text={t('my.usage.item2_dot3')} />
          </div>
          <div>
            <Title title={t('my.usage.item3_title')} />
            <DotText text={t('my.usage.item3_dot1')} />
            <DotText text={t('my.usage.item3_dot2')} />
            <DotText text={t('my.usage.item3_dot3')} />
          </div>
          <div>
            <Title title={t('my.usage.item4_title')} />
            <DotText text={t('my.usage.item4_dot1')} />
            <DotText text={t('my.usage.item4_dot2')} />
          </div>
          <div>
            <Title title={t('my.usage.item5_title')} />
            <DotText text={t('my.usage.item5_dot1')} />
            <DotText text={t('my.usage.item5_dot2')} />
          </div>
          <div>
            <Title title={t('my.usage.item6_title')} />
            <DotText text={t('my.usage.item6_dot1')} />
          </div>
        </div>
      </div>
    </FullHeightContainer>
  );
}

export default UsageGuidePage;
